import React, { useState, useEffect, useRef, Fragment } from "react";
import { useForm, Controller } from "react-hook-form";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, Autocomplete, TextField, Modal } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from "../../../assets/images/delete.png";
import { IoMdWarning } from "react-icons/io";
import { faImages, faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { FileUploader } from "react-drag-drop-files";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaHotel } from "react-icons/fa";
import CarouselComponent from "./CarouselComponent ";
import DeleteBannerImage from "./DeleteBannerImage";
import CircularProgress from "@mui/material/CircularProgress";
import Custom_Paingation from "../../core/BaseComponents/Custom_Paingation";
import { ScrollToTop, getChainIdLS, isValidRole } from "../../../utils/utils";
import { useSelector } from "react-redux";
import { ChromePicker, SketchPicker } from "react-color";
import ClosedIcon from "@mui/icons-material/Close";
import ImageResolutionTooltip from "../ConfigurationNewHotel/ImageResolutionTooltip";
import { Tabs, Tab, Box } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import ConfigurationManagementForm from "./ConfigurationManagementForm/ConfigurationManagementForm";
import ScreensaverConfiguration from "./ScreensaverConfiguration/ScreensaverConfiguration";
import WelcomeMessage from "./WelcomeMessage/WelcomeMessage"
import { BsEye } from "react-icons/bs";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      // className="tabpanelcustom"
      {...other}
    >
      {value === index && (
        <Box>
          {children}
          {/* <Typography>{children}</Typography> */}
        </Box>
      )}
    </div>
  );
};

function GroupRooms() {
  const [bannerImagesList, setBannerImagesList] = useState({});
  const [roomTypesMaster, setRoomTypesMaster] = useState([]);
  const [confirmDeleteBannerRow, setConfirmDeleteBannerRow] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deleteBannerPopUp, setDeleteBannerPopUp] = useState(false);
  const [deleteBannerImagePopUpAPI, setDeleteBannerImagePopUpAPI] =
    useState(false);
  const [editBannerConfig, setEditBannerConfig] = useState(false);
  const [editBannerRowUpdate, setEditBannerRowUpdate] = useState(false);
  const [createBannerSuccessMsg, setCreateBannerSuccessMsg] = useState("");
  const [editBannerSid, setEditBannerSid] = useState("");

  const [configurationPopup, setConfigurationPopup] = useState(false)
  const [configurationParentId, setConfigurationParentId] = useState(null)
  // const [publishUnPublishPopUp, setPublishUnPublishPopUp] = useState(false);
  // const [flag, setFlag] = useState(false);
  const [loader, setLoader] = useState(false);

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("");
  const [inputPageValue, setInputPageValue] = useState(1);

  const recordsPerPage = 10;

  const [value, setValue] = useState(0);
  
    function a11yProps(index) {
      return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
        className: `eachtab ${value === index ? "Mui-selected" : ""}`,
      };
    }
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    control,
  } = useForm({
    mode: "onChange",
  });

  const todayDate = dayjs().format("YYYY-MM-DDTHH:mm");

  const { chainId } = useSelector((state) => state.chainIdReducer);
  let validPermissionClassName = isValidRole("GROUP_ROOMS_MODIFY")
    ? ""
    : "btn-disable-permission";

  const onSubmit = (data) => {
    const payload = {
        scheduledStartTime: data?.scheduledStartTime,
        scheduledEndTime: data?.scheduledEndTime,
        roomNumbers: data?.roomNumber,
        name: data?.groupName
      }
    let method = "POST";
    let url = `/scheduled-box-config`;

    if (editBannerRowUpdate) {
      method = "PUT";
      url = `/scheduled-box-config?id=${editBannerSid?.id}`;
    }
    setLoader(true);
    callAPI(url, method, payload, { chainId: getChainIdLS() })
      .then(function (response) {
        reset({
          groupName: "",
          roomNumber: [],
          scheduledStartTime: "",
          scheduledEndTime: "",
        });
        setLoader(false);
        // setCreateBannerSuccessMsg(response?.message);
        setCreateBannerSuccessMsg("Record Created Successfully.")
        BannerListApi();
        setEditBannerSid("");
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  const isBannerDeletedRef = useRef({
    isBannerDeletedModalData: null,
    userConformationModalData: null,
  });

  const isPublishedUnPublishedRef = useRef({
    isPublishUnPublishModalData: null,
  });

  const isBannerImaageDeletedRef = useRef({
    isBannerImageDeletedModalData: null,
    deleteBannerConformationModalData: null,
  });

  const deleteBannerRowPopUpHandler = (row) => {
    setDeleteBannerPopUp(true);
    const newModalRefData = {
      isBannerDeletedModalData: {
        row,
      },
      userConformationModalData: null,
    };
    isBannerDeletedRef.current = newModalRefData;
  };

  const deleteBannerHandler = () => {
    setConfirmValidate(true);
    if (confirmDeleteBannerRow === "") {
      return;
    }

    if (
      confirmDeleteBannerRow ===
      `Delete Group Room ${isBannerDeletedRef.current?.isBannerDeletedModalData.row.name}`
    ) {
      setConfirmValidate(false);
      const { row } = isBannerDeletedRef.current?.isBannerDeletedModalData;
      callAPI(
        `/scheduled-box-config?id=${row?.id}`,
        "DELETE",
        {},
        { chainId: getChainIdLS() }
      )
        .then((response) => {
          let successMessage = response.message;
          const newModalRefData = {
            isBannerDeletedModalData: null,
            userConformationModalData: {
              successMessage,
            },
          };
          isBannerDeletedRef.current = newModalRefData;
          cancelBannerHandler();
          BannerListApi();
        })
        .catch((error) => {
          console.warn(error);
        });
    }
    reset({
      groupName: "",
      roomNumber: [],
      scheduledStartTime: "",
      scheduledEndTime: "",
    });
  };

  const deleteBannerImageHandlerApi = () => {
    const { bannerImage, bannerConfigId } =
      isBannerImaageDeletedRef.current?.isBannerImageDeletedModalData;
    callAPI(
      `/grouped-room/image?bannerConfigId=${bannerConfigId}&imageId=${bannerImage?.id}`,
      "DELETE",
      {},
      { chainId: getChainIdLS() }
    )
      .then((response) => {
        let successMessage = response.message;
        const newModalRefData = {
          isBannerImageDeletedModalData: null,
          deleteBannerConformationModalData: {
            successMessage,
          },
        };
        isBannerImaageDeletedRef.current = newModalRefData;
        BannerListApi();
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  const renderActionIcon = (row) => {
    return (
      isValidRole("GROUP_ROOMS_MODIFY")?<>
        {!row?.published ? (
          <>
            <Tooltip title="Edit" arrow>
              <MdModeEditOutline
                className="edit-icon-enable"
                onClick={() => {
                  setEditBannerConfig(true);
                  setEditBannerSid(row);
                }}
              />
            </Tooltip>
            <Tooltip title="Delete" className="cursor-pointer" arrow>
              <DeleteIcon
                className="delete-icon-enable"
                onClick={() => {
                  deleteBannerRowPopUpHandler(row);
                }}
              />
            </Tooltip>
          </>
        ) : (
          <>
            <Tooltip title="Un-Publish to perform actions">
              <span>
                <MdModeEditOutline className="edit-icon-disable" arrow />
              </span>
            </Tooltip>
            <Tooltip title="Un-Publish to perform actions">
              <DeleteIcon className="delete-icon-disable" arrow />
            </Tooltip>
          </>
        )}
      </>:
      <>
      <Tooltip title="Don't have permission to edit">
        <span>
          <MdModeEditOutline className="edit-icon-disable" arrow />
        </span>
      </Tooltip>
      <Tooltip title="Don't have permission to delete">
        <DeleteIcon className="delete-icon-disable" arrow />
      </Tooltip>
    </>
    );
  };

  const columns = [
    {
      field: "createdOn",
      headerName: "Created On",
      flex: 1,
      row: true,
      renderCell: (row) => (
        <p className="mb-0">
          {dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}
        </p>
      ),
    },
    { field: "name", headerName: "Name", flex: 1 },
    {
      field: "roomNumbers",
      headerName: "Room Number",
      flex: 1,
      row: true,
      renderCell: (row) =>
        row?.roomNumbers?.map((item, index) => (
          <span>
            {index ? "," : ""} {item}
          </span>
        )),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      row: true,
      renderCell: (row) => (
        <strong className={`mb-0 ${row?.status}`}>{row?.status}</strong>
      ),
    },
    { field: "Preview", headerName: "Config Edit", flex: 1, disableSortIcon: true, row: true, 
    renderCell: (row) => <span><button onClick={() => { setConfigurationParentId(row?.id); setConfigurationPopup(true) }} className={`create-btn`}>Add / Edit Config</button></span>
    },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  const BannerListApi = () => {
    const apiPath = `/scheduled-box-config/search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
    callAPI(apiPath, "POST", {}, { chainId: getChainIdLS() })
      .then((response) => {
        setBannerImagesList(response);
        setTotalPageCount(response?.totalPages ? response?.totalPages : 1);
        setPaginationError("");
      })
      .catch((err) => console.warn(err.message));
  };

  useEffect(() => {
    BannerListApi();
  }, [selectedPage, chainId]);

  useEffect(() => {
    callAPI("/get-room-no", "GET", {}, { chainId: getChainIdLS() })
      .then((res) => {
        setRoomTypesMaster(res);
      })
      .catch((err) => {
        console.warn(err.message);
      });
    cancelBannerHandler();
  }, [chainId]);

  const popupCloseHandler = () => {
    setDeleteBannerPopUp(false);
    // setPublishUnPublishPopUp(false);
    setDeleteBannerImagePopUpAPI(false);
  };

  useEffect(() => {
    if (editBannerConfig) {
      getBannerListSidHandler();
      setEditBannerConfig(false);
    }
    ScrollToTop();
  }, [editBannerConfig, chainId]);

  const getBannerListSidHandler = () => {
    callAPI(`/scheduled-box-config?id=${editBannerSid?.id}`,"GET",{},{ chainId: getChainIdLS() })
      .then(function (response) {
        //.format("YYYY-MM-ddTHH:mm")
        const startTime = response.scheduledStartTime
          ? new Date(response.scheduledStartTime).toISOString()?.slice(0, 16)
          : "";
        const endTime = response.scheduledEndTime
          ? new Date(response.scheduledEndTime).toISOString()?.slice(0, 16)
          : "";
        const payload = {
          groupName: response?.name,
          roomNumber: response.roomNumbers,
          scheduledStartTime: startTime,
          scheduledEndTime: endTime,
        };
        reset(payload);
        setEditBannerRowUpdate(true);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  };

  const resetLayoutHandler = () => {
    reset();
  };

  const cancelBannerHandler = () => {
    reset({
      groupName: "",
      roomNumber: [],
      scheduledStartTime: "",
      scheduledEndTime: "",
    });
    setEditBannerRowUpdate(false);
    setEditBannerSid("");
    setEditBannerConfig(false);
  };

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value);
    setPaginationError("");
    setSelectedPage(value);
  };

  const categoryModalCloseHandler = () => {
    // categoryPopupCloseHandler();
    // cancelHotelHandler();
    setConfigurationParentId(null)
    setConfigurationPopup(false)
  };

  return (
    <div className="row config-hotel config-management-form">
      <div className="col-12 left-column">
        {loader && (
          <div className="circular-progress">
            <CircularProgress />
          </div>
        )}
        <form
          autoComplete="off"
          onSubmit={handleSubmit(onSubmit)}
          className="hotel-list-form"
        >
          <div className="row">
            <div className="left-column-header">
              <p>
                {editBannerRowUpdate
                  ? "Edit Group Room Details"
                  : "Add Group Room Details"}
              </p>
            </div>
            <div className="form-group-hotel col-3">
              <div className="floating-label">
                <FaHotel className="new-hotel-icons" />
                <input
                  id="groupName"
                  maxLength={40}
                  placeholder=""
                  {...register("groupName", {
                    required: "Enter Group Room Name",
                  })}
                />
                <label htmlFor="name">Enter Group Room Name</label>
              </div>
              {errors.groupName && (
                <small className="required">{errors.groupName.message}</small>
              )}
            </div>

            <div className="col-3 form-group-hotel">
              <div className="floating-select-label">
                <Controller
                  name="roomNumber"
                  control={control}
                  rules={{
                    validate: (value) =>
                      (Array.isArray(value) && value?.length > 0) ||
                      "Please Select Room Number",
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${
                        field?.value && field?.value?.length > 0
                          ? "Mui-focused"
                          : ""
                      }`}
                      limitTags={2}
                      disablePortal
                      multiple
                      options={roomTypesMaster}
                      getOptionLabel={(option) => option.toString()}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                      }}
                      value={field.value || []}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Select Room Number"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.roomNumber && (
                <small className="required">{errors.roomNumber?.message}</small>
              )}
            </div>
            <div className="form-group-hotel col-3">
              <div className="floating-label">
                {/* <FaHotel className="new-hotel-icons" /> */}
                <input
                  id="scheduledStartTime"
                  type="datetime-local"
                  min={todayDate}
                  placeholder=""
                  {...register("scheduledStartTime", {
                    required: "Enter Schedule start date",
                  })}
                />
                <label htmlFor="name">Enter Schedule start date</label>
              </div>
              {errors.scheduledStartTime && (
                <small className="required">
                  {errors.scheduledStartTime.message}
                </small>
              )}
            </div>
            <div className="form-group-hotel col-3">
              <div className="floating-label">
                {/* <FaHotel className="new-hotel-icons" /> */}
                <input
                  id="scheduledEndTime"
                  type="datetime-local"
                  min={todayDate}
                  placeholder=""
                  {...register("scheduledEndTime", {
                    required: "Enter Schedule end date",
                  })}
                />
                <label htmlFor="name">Enter Schedule end date</label>
              </div>
              {errors.scheduledEndTime && (
                <small className="required">
                  {errors.scheduledEndTime.message}
                </small>
              )}
            </div>
            <div className="text-end">
              <div>
                <button
                  type="button"
                  className="clear-btn me-2"
                  onClick={cancelBannerHandler}
                >
                  {editBannerRowUpdate ? "Cancel" : "Clear All"}
                </button>
                {editBannerRowUpdate && (
                  <>
                    <button
                      type="button"
                      className="clear-btn me-2"
                      onClick={resetLayoutHandler}
                    >
                      Reset
                    </button>
                  </>
                )}
                {/* {!editBannerRowUpdate && <button type="button" disabled={isSubmitting} className="disable-btn me-2" onClick={handleSubmit(onSave)}>Save</button>} */}
                <button
                  type="button"
                  disabled={isSubmitting}
                  className={`create-btn ${validPermissionClassName} `}
                  onClick={handleSubmit(onSubmit)}
                >
                  {editBannerRowUpdate ? "Update" : "Save"}
                </button>
              </div>
            </div> 
          </div>
        </form>
        <div className="hotel-list">
          <p>
            <b>Group Rooms List</b>
          </p>
          <TableWrapper
            data={bannerImagesList?.response}
            columns={columns}
            module="group-room"
            noPagination={true}
          />
          <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          />
        </div>
        <Modal
              open={configurationPopup}
              onClose={categoryModalCloseHandler}
              className="basic-modal"
            >
                <div className={`basic-modal_root col-11 categoryModal p-4`}>
            <Box className="boxroot disable-tab">
                <AppBar position="static">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{
                    hidden: true,
                    style: { transition: "none" },
                    }}
                >
                    <Tab label="Hero Banner" {...a11yProps(0)} />
                    <Tab label="Screensaver" {...a11yProps(1)} />
                    <Tab label="WelcomeMessage" {...a11yProps(2)} />
                </Tabs>
                </AppBar>

                <TabPanel value={value} index={0}>
                <ConfigurationManagementForm parentId={configurationParentId} setValue={setValue}/>
                </TabPanel>
                <TabPanel value={value} index={1}>
                <ScreensaverConfiguration parentId={configurationParentId} setValue={setValue}/>
                </TabPanel>
                <TabPanel value={value} index={2}>
                <WelcomeMessage parentId={configurationParentId} setValue={setValue}/>
                </TabPanel>
            </Box>
            </div>
            </Modal>
      </div>
      <DeleteBannerImage
        deleteBannerImagePopUp={deleteBannerImagePopUpAPI}
        popupCloseHandler={popupCloseHandler}
        deleteBannerImageHandlerApi={deleteBannerImageHandlerApi}
        isBannerImaageDeletedRef={isBannerImaageDeletedRef}
      />
      {/* <ConfigrationActions /> */}
      <BasicModal
        popupOpen={deleteBannerPopUp}
        bodyMessage={
          <>
            <img src={deleteImg} alt="approve" className="w-40px" />
            <div className="delete-hotel mb-3">
              {isBannerDeletedRef.current?.isBannerDeletedModalData ? (
                <div className="confirm-delete-hotel">
                  <p>
                    Do you really want to Delete Group Room "
                    <b>
                      {
                        isBannerDeletedRef.current?.isBannerDeletedModalData.row
                          .name
                      }
                    </b>
                    " ?
                  </p>
                  <p className="warning">
                    <IoMdWarning /> Warning
                  </p>
                  <p>
                    Group Room "
                    {
                      isBannerDeletedRef.current?.isBannerDeletedModalData.row
                        .name
                    }
                    " will be permanently deleted <br />
                    Deleting the specified Group Room can't be undone.
                  </p>
                  <p className="mt-3">
                    To confirm deletion, type "Delete Group Room{" "}
                    {
                      isBannerDeletedRef.current?.isBannerDeletedModalData.row
                        .name
                    }
                    "
                  </p>
                  <div className="form-group-hotel mt-3">
                    <div className="floating-label">
                      <input
                        id="deleteHotel"
                        // maxLength={30}
                        placeholder=""
                        onChange={(e) =>
                          setConfirmDeleteBannerRow(e.target.value)
                        }
                      />
                      <label htmlFor="deleteHotel">Delete Group Room</label>
                    </div>
                    {confirmDeleteBannerRow === "" && confirmValidate ? (
                      <p className="text-start">
                        <small className="required">
                          Please Enter Delete Group Room
                          {
                            isBannerDeletedRef.current?.isBannerDeletedModalData
                              .row.name
                          }
                        </small>
                      </p>
                    ) : confirmDeleteBannerRow !==
                        `Delete Group Room ${isBannerDeletedRef.current?.isBannerDeletedModalData.row.name}` &&
                      confirmValidate ? (
                      <p className="text-start">
                        <small className="required">
                          Please Enter Delete Group Room{" "}
                          {
                            isBannerDeletedRef.current?.isBannerDeletedModalData
                              .row.name
                          }
                        </small>
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : (
                isBannerDeletedRef.current?.userConformationModalData
                  ?.successMessage
              )}
            </div>
          </>
        }
        footer={
          isBannerDeletedRef.current?.isBannerDeletedModalData
            ? {
                primaryButton: {
                  buttonName: "Cancel",
                  action: popupCloseHandler,
                },
                secondaryButton: {
                  buttonName: "Delete",
                  action: deleteBannerHandler,
                },
              }
            : {
                secondaryButton: {
                  buttonName: "OK",
                  action: popupCloseHandler,
                },
              }
        }
      />

      <BasicModal
        popupOpen={createBannerSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createBannerSuccessMsg}</p>}
        // customcss={true}
        footer={{
          secondaryButton: {
            buttonName: "OK",
            action: () => {
              setCreateBannerSuccessMsg("");
              setEditBannerRowUpdate(false);
              BannerListApi();
            },
            buttonPrimaryCustomCss: "cancel-btn_new",
          },
        }}
      />
    </div>
  );
}

export default GroupRooms;
